// Work-related constants centralised here for reuse

export const photos = 'photos';
export const guestUpload = 'guestupload';
export const albumSelection = 'albumselection';
export const blacklistReview = 'blacklistreview';
export const userFolders = 'userfolders';
export const videos = 'videos';
export const albums = 'albums';
export const portfolio = 'portfolio';
export const sharedLinks = 'shared_links';
export const quoteForm = 'quote_form';
export const userRatings = 'user_ratings';
export const dashboard = 'dashboard';
export const activity = 'activity';
export const past_face_searches = 'past_face_searches';
export const registerSelfie = 'register_selfie';
export const hide = 'hide';
export const download = 'download';
export const deleteUploads = 'delete_guest_gallery';
export const likePhotos = 'like_photos';
export const viewPhotos = 'view_photos';
export const flagPhotos = 'flag_photos';
export const approvePhoto = 'approve_photos';
export const addTo = 'addTo';
export const firefox = 'firefox';
export const chrome = 'chrome';
export const safari = 'safari';
export const edge = 'edge';
export const opera = 'opera';
export const android = 'android';
export const ios = 'ios';
export const STORAGE_KEY = 'api_guard_state';

export const allPhotos = 'showall';
export const privatePhotos = 'private';
export const publicPhotos = 'public';

export const trashIcon = 'https://assets.eventgraphia.com/site_media/react/restore.png';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.eventgraphia.app&hl=en_IN';
export const APP_BANNER_DISMISSED_KEY = 'eg_play_store_banner_dismissed';

// Breakpoint column presets for Masonry
export const grid_version_1 = {
	default: 5,
	1300: 5,
	800: 4,
	600: 2,
};

export const grid_version_2 = {
	default: 4,
	1300: 4,
	800: 3,
	600: 2,
};
